//Reset data
export const RESET = "USER_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "USER_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "USER_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "USER_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "USER_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "USER_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "USER_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "USER_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "USER_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "USER_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "USER_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "USER_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "USER_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "USER_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "USER_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "USER_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "USER_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "USER_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "USER_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "USER_LIST_SET_MODAL_TYPE"